export default {
  path: '/servico-at/:service_id/medidor/:meter_id',
  component: () => import('@/components/pages/ATServices/ExpertMode/ExpertModeInspection')
}
